module.exports = {
        srcSet: __webpack_public_path__ + "static/media/storage_mobile-640.bf584209.webp"+" 640w",
        images: [{path: __webpack_public_path__ + "static/media/storage_mobile-640.bf584209.webp",width: 640,height: 427}],
        src: __webpack_public_path__ + "static/media/storage_mobile-640.bf584209.webp",
        toString: function(){return __webpack_public_path__ + "static/media/storage_mobile-640.bf584209.webp"},
        
        width: 640,
        height: 427
      }